import EngineInformation from "./EngineInformation";
import EngineInformationV2 from "./EngineInformation_V2";
import TechnicalRecords from "./TechnicalRecords";
import TechnicalRecordsV2 from "./TechnicalRecords_V2";
import EngineCondition from "./EngineCondition";
import EngineStand from "./EngineStand";
import EngineInspectionInfoV2 from "./EngineInspectionInfo_V2";
import PowerPlant from "./PowerPlant";
import FleetComposition from "./FleetComposition";
import TechnicalSummary from "./TechnicalSummary";
import ConclusionV2 from "./Conclusion_V2";
import InstalledEngine from "./InstalledEngine";
import PhysicalReview from "./PhysicalReview";
import MliTab from "./MliTab";
import ExportDialog from "./ExportDialog";
import Operator from "./Operator";
export {
    EngineInformation,
    EngineInformationV2,
    TechnicalRecords,
    TechnicalRecordsV2,
    EngineCondition,
    EngineStand,
    EngineInspectionInfoV2,
    PowerPlant,
    FleetComposition,
    TechnicalSummary,
    ConclusionV2,
    InstalledEngine,
    PhysicalReview,
    MliTab,
    ExportDialog,
    Operator
}

export const gtalable_dropdownField =
    [{lable: "is aware that SAEL's engine is leased:", value: 'is_aware', dropdown: ['YES', 'NO'] },
    { lable: "is familiar with the current condition of the engine before start of MLI:", value: "is_corrent_condition", dropdown: ['YES', 'NO'] },
    { lable: "is aware of the policy on using PMA parts in the gaspath of the engine:", value: "is_pma", dropdown: ['YES', 'NO'] },
    { lable: "is aware of the policy on using DER repairs on the engine:", value: "is_der", dropdown: ['YES', 'NO'] },
    { lable: "is familiar with the Shop Visit provision in the lease:", value: "is_shop_visit", dropdown: ['YES', 'NO'] },
    { lable: "is familiar with the redelivery conditions in the lease:", value: "is_redelivery", dropdown: ['YES', 'NO'] },
    { lable: "is familiar with the replacement parts clause in the lease:", value: "is_replacement", dropdown: ['YES', 'NO'] },
    { lable: "is aware of the QEC specification delivered with the engine:", value: "is_qec", dropdown: ['YES', 'NO'] },
    { lable: "is aware of the transportation stand delivered with the engine:", value: "is_transportation", dropdown: ['YES', 'NO'] },
    ]

export const engineConditionConfig = [
    { description: 'Fan Case', conditionKey: 'fan_case', noteKey: 'fan_case', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Fan Blade', conditionKey: 'fan_blade', noteKey: 'fan_blade', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Fan Inlet', conditionKey: 'fan_inlet', noteKey: 'fan_inlet', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Rotation of Spools', conditionKey: 'rotation_of_spools', noteKey: 'rotation_of_spools', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Evidence -Leakage', conditionKey: 'evidence_leakage', noteKey: 'evidence_leakage', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Exhaust Area', conditionKey: 'exhaust_area', noteKey: 'exhaust_area', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Spotcheck LRU S/N', conditionKey: 'spotcheck_lru_sn', noteKey: 'spotcheck_lru_sn' },
    { description: 'Photo', conditionKey: 'photo_condition', noteKey: 'photo_note', message: "To obtain and attach photos of the engine (if possible)" }
];
export const engineRemovedConfig = [
    { description: 'Fan Case', conditionKey: 'fan_case', noteKey: 'fan_case', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Fan Blade', conditionKey: 'fan_blade', noteKey: 'fan_blade', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Fan Inlet', conditionKey: 'fan_inlet', noteKey: 'fan_inlet', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Rotation of Spools', conditionKey: 'rotation_of_spools', noteKey: 'rotation_of_spools', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Core Area', conditionKey: 'core_area', noteKey: 'core_area', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Evidence -Leakage', conditionKey: 'evidence_leakage', noteKey: 'evidence_leakage', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Exhaust Area', conditionKey: 'exhaust_area', noteKey: 'exhaust_area', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Spotcheck LRU S/N', conditionKey: 'spotcheck_lru_sn', noteKey: 'spotcheck_lru_sn' },
    { description: 'Tag', conditionKey: 'removed_engine_tag', noteKey: 'removed_engine_tag',},
    { description: 'Photo', conditionKey: 'photo_condition', noteKey: 'removed_engine_photo_availability', message: "To obtain and attach photos of the engine (if possible)" }
];


